import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserGraph } from 'app/model/user-graph';
import { Observable } from 'rxjs';
import { urpiweb } from 'app/shared/helpers/constants';
@Injectable({
  providedIn: 'root'
})
export class GraphWindowsService {
  constructor(private http: HttpClient) { }
  getUserGraph(): Observable<UserGraph> {
    return this.http.get<UserGraph>('https://graph.windows.net/me?api-version=1.6', this.getHttpOptiones());
  }
  private getHttpOptiones(): Object{
    return {
      headers: new HttpHeaders({
        // "Access-Control-Allow-Origin": "http://localhost:4200",
        'Authorization': `Bearer ${urpiweb.auth.token}`,
         // 🔒 Headers de seguridad (normalmente se colocan en el servidor)
      /*  
  "X-Frame-Options": "DENY",
  "X-Content-Type-Options": "nosniff",
  "Strict-Transport-Security": "max-age=63072000; includeSubDomains; preload",
  "Content-Security-Policy": "default-src 'self'",
  "Referrer-Policy": "no-referrer",
  "Permissions-Policy": "camera=(), microphone=(), geolocation=()",
  "Cross-Origin-Embedder-Policy": "require-corp",
  "Cross-Origin-Resource-Policy": "same-origin",
  "Cross-Origin-Opener-Policy": "same-origin"*/
      })
    };
  }
}